import NavTabs from 'shared/components/NavTabs/NavTabs';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import routes from 'router/routes';
import { AccessRoles } from 'shared/auth';
import { isAllowed, useAuthContext } from 'context/AuthContext';
import { useEffect, useMemo } from 'react';
import { Paper, Stack, styled } from '@mui/material';
import { Path } from 'shared/types';
import usePlanStore from 'store/planStore';

const Wrapper = styled(Stack)(({ theme }) => ({
  minHeight: 'calc(100% - 74px)',
  backgroundColor: theme.palette.lightGrey.main,
}));
const Content = styled(Paper)({
  borderRadius: 0,
  display: 'flex',
  flexDirection: 'column',
  margin: '0',
  flexGrow: 1,
  boxShadow: 'none',
});

function Calculator(): JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();
  const { userRoles } = useAuthContext();
  const { t } = useTranslation();
  const { isPlanCreating } = usePlanStore();

  const filteredPaths = useMemo<Path[]>(
    () =>
      [
        {
          to: routes.mediaPlanning,
          label: t('mediaplanning'),
          show: isAllowed(
            [AccessRoles.FULL_ACCESS, AccessRoles.ONLINE_CAMPAIGNS],
            userRoles
          ),
        },
      ].filter(({ show }) => show),
    [t, userRoles]
  );

  useEffect(() => {
    const currentPath = location.pathname;
    const currentPathIndex = filteredPaths.findIndex(
      ({ to }) => `/${to}` === currentPath
    );

    if (currentPathIndex === -1) {
      const firstPath = filteredPaths[0];
      if (firstPath) {
        navigate(firstPath.to);
      }
    }
  }, [filteredPaths, navigate, location]);

  return (
    <Wrapper>
      <Content
        sx={{
          backgroundColor: '#FAFAFA', // todo add as default color and remove later unnecessary
        }}
      >
        {!isPlanCreating && (
          <Stack sx={{ mx: '20px', mt: '18px' }}>
            <NavTabs paths={filteredPaths} />
          </Stack>
        )}
        <Stack flexGrow={1}>
          <Outlet />
        </Stack>
      </Content>
    </Wrapper>
  );
}

export default Calculator;
